// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import KPop from '@ckienle/k-pop'
import VueLazyload from 'vue-lazyload';
import VueStickyDirective from "@renatodeleao/vue-sticky-directive";

import App from './App'

Vue.config.productionTip = false

Vue.use(KPop)
Vue.use(VueStickyDirective);
Vue.use(VueLazyload, {
  adapter: {
    loaded({ el }) {
      const srcSet = el.attributes['data-srcset'];
      if (srcSet) {
        el.setAttribute('srcSet', srcSet.value);
      }
    },
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js